<template>
  <el-container class="home-layout">
    <el-aside
      class="home-aside"
      :width="asideWidth"
      :class="{ 'is-collapsed': isCollapse }"
    >
      <CommonAside :is-collapse="isCollapse" />
    </el-aside>
    <el-container class="home-right">
      <el-header class="home-header" height="60px">
        <containers
          :is-collapse="isCollapse"
          @toggle-collapse="toggleCollapse"
        />
      </el-header>
      <el-main class="home-main">
        <router-view />
      </el-main>
    </el-container>
  </el-container>
</template>
<script>
import CommonAside from '../components/CommonAside/CommonAsides.vue'
import containers from '../components/container/container.vue'

const STORAGE_KEY = 'asideCollapse'

export default {
  components: { CommonAside, containers },
  data () {
    return {
      isCollapse: localStorage.getItem(STORAGE_KEY) === 'true'
    }
  },
  computed: {
    asideWidth () {
      return this.isCollapse ? '60px' : '10%'
    }
  },
  methods: {
    toggleCollapse () {
      this.isCollapse = !this.isCollapse
      localStorage.setItem(STORAGE_KEY, String(this.isCollapse))
    }
  }
}
</script>
<style scoped>
.home-layout {
  display: flex;
  width: 100%;
  height: 100vh;
  overflow: hidden;
}

.home-aside {
  flex-shrink: 0;
  height: 100vh;
  background-color: #F5F9FC;
  color: #333;
  text-align: center;
  overflow-x: hidden;
  overflow-y: auto;
  transition: width 0.3s ease;
  z-index: 999;
}

.home-right {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-width: 0;
  height: 100vh;
  overflow: hidden;
  transition: width 0.3s ease;
}

.home-header {
  padding: 0;
  background-color: #fff;
  color: #333;
  text-align: center;
  line-height: 60px;
  flex-shrink: 0;
}

.home-main {
  flex: 1;
  padding: 20px 0;
  background-color: #fff;
  overflow: auto;
  min-width: 0;
}

@media (max-width: 768px) {
  .home-aside {
    display: none;
  }

  .home-header {
    margin-left: 0;
  }

  .home-main {
    width: 100%;
    padding: 0;
  }
}
</style>
